module.exports = __webpack_public_path__ + "img/setUpCards_2.62141a6a.jpg";